import React, { useEffect, useState, useContext } from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import moment from 'moment'
import { getDuration } from '../../utils'
import TripsContext from '../../contexts/TripsContext'

type IProp = {
    trip: any
    isActive: boolean
    address?: string
    driver?: string
    onClick(trip): void
    onMouseOver?(): void
}

const TripCard = ({ trip, address, driver, isActive, onClick }: IProp): JSX.Element => {
    const [start, setStart] = useState('-')
    const [startTime, setStartTime] = useState('-')
    const [endTime, setEndTime] = useState('-')
    const { tripHoverActive, setTripHoverActive } = useContext(TripsContext)

    useEffect(() => {
        if (trip) {
            if (trip?.start) {
                setStart(moment(trip.start, 'x').format('DD/MM/YYYY'))
                setStartTime(moment(trip.start, 'x').format('HH:mm'))
            }

            if (trip?.end) setEndTime(moment(trip.end, 'x').format('HH:mm'))
        }
    }, [trip])

    return (
        <StyledTrips
            onMouseEnter={() => setTripHoverActive(trip)}
            onMouseLeave={() => setTripHoverActive(undefined)}
            isHover={trip?.uid === tripHoverActive?.uid}
            isActive={isActive}
            onClick={onClick}
        >
            <StyledRow className="card-border-separator">
                <div className="style-row-details ">
                    <div className="item-row-date item-row-separator">{start}</div>
                    <div className="item-row-time">
                        {startTime} {i18n('to')} {endTime}
                    </div>
                    <div className="item-row-address">
                        <div className="text-wrap">
                            <i className="far fa-map-marker-alt"> </i>
                            {address || 'N/D'}
                        </div>
                    </div>
                </div>

                {/* <StyledButtonAlert>
                    <i className="far fa-bell"></i>3
                </StyledButtonAlert> */}
            </StyledRow>

            <StyledRow>
                <div className="style-row-details flex-1">
                    <div className="item-row-trip item-row-separator">
                        {trip?.isOnGoing && <span className="trip-on-going">{i18n('On Going')}</span>}
                        {!trip?.isOnGoing && (
                            <span>
                                <i style={{ marginRight: 4 }} className="far fa-clock" />
                                {getDuration(trip.start, trip.end)}
                            </span>
                        )}
                    </div>
                    <div className="item-row-driver">
                        <i className="far fa-user"> </i>
                        {driver}
                    </div>
                </div>

                <div className="item-row-related-schedule">
                    {/* TO-DO <a>
                        <i className="far fa-calendar-alt"> </i>
                        {i18n('Related Schedules')}
                    </a> */}
                </div>
            </StyledRow>
        </StyledTrips>
    )
}

export default React.memo(TripCard)

const StyledTrips = styled.div`
    background: ${({ theme, isHover }) => (isHover ? theme['blue-200'] : theme['gray-0'])};
    height: 121px;
    width: 100%;
    padding: 18px 16px;
    border-radius: 3px;
    border-color: ${({ theme, isActive }) => (isActive ? theme['blue-500'] : theme['gray-400'])};
    border-style: solid;
    border-width: ${({ isActive }) => (isActive ? '2px' : '1px')};

    box-sizing: border-box;
    margin-bottom: 8px;
    cursor: pointer;

    .text-wrap {
        width: 400px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .trip-on-going {
        font-weight: 600;
        font-size: 11px;
        color: #01b286;
    }

    i {
        color: ${({ theme }) => theme['gray-600']};
    }

    &:hover {
        background: ${({ theme }) => theme['blue-200']};

        .card-border-separator {
            &:first-of-type {
                border-color: ${({ theme }) => theme['gray-400']};
            }
        }

        .item-row-separator {
            &::after {
                color: ${({ theme }) => theme['gray-400']};
            }
        }
    }

    .card-border-separator {
        &:first-of-type {
            justify-content: center;
            border-bottom: 1px solid ${({ theme, isHover }) => (isHover ? theme['gray-400'] : theme['gray-200'])};
            padding-bottom: 8px;
            margin-bottom: 8px;
        }
    }

    .item-row-container-alert {
        display: flex;
        justify-content: end;
        flex: 2;
    }

    .item-row-date,
    .item-row-time {
        font-size: 13px;
        font-weight: 600;
        color: ${({ theme }) => theme['gray-800']};

        span {
            font-weight: 400;
        }
    }

    .item-row-address {
        font-size: 12px;
        font-weight: 400;
        color: ${({ theme }) => theme['gray-700']};
        width: 100%;
        margin-top: 8px;

        .fa-map-marker-alt {
            margin-right: 4px;
        }
    }

    .item-row-trip {
        font-size: 12px;
    }

    .item-row-driver {
        font-size: 12px;

        .fa-user {
            margin-right: 8px;
        }
    }

    .item-row-related-schedule {
        font-size: 13px;
        font-weight: 600;

        .fa-calendar-alt {
            margin-right: 4px;
        }
    }

    .item-row-separator {
        &::after {
            content: '|';
            margin: 0px 8px;
            color: ${({ theme, isHover }) => (isHover ? theme['gray-400'] : theme['gray-300'])};
        }
    }
`

const StyledRow = styled.div`
    display: flex;
    align-items: center;

    .style-row-details {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
    }
`

const StyledButtonAlert = styled.button`
    padding: 2px 8px;
    font-size: 12px;
    border-radius: 3px;
    font-weight: 400;
    background: transparent;
    color: ${({ theme }) => theme['gray-600']};
    border: 1px solid ${({ theme }) => theme['gray-600']};
    position: relative;
    left: 5px;
    .fa-bell {
        margin-right: 4px;
    }
`
